import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import * as aa from '../actions/authentication/authAction';
import {startSession} from "../actions/user/platformUserAction";

class AuthContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getTransferInfo(this.props.match.params.nonce);
    }

    componentDidMount() {
        window.addEventListener('DOMContentLoaded', this.handleLoad);
    }

    handleLoad = () => {
        if (window.parent) {
            window.parent.postMessage("iframeLoaded", "*");
        }
    };

    render() {
        const {redirectTo, status} = this.props;

        if (status === "TransferInfoReceived") {
            this.props.startSession();

            if (redirectTo.length === 0) {
                this.props.history.push('/assignments');
            } else {
                window.location.replace(redirectTo);
            }
        }
        return (
            <div/>
        );
    }
}

AuthContainer.propTypes = {
    getTransferInfo: PropTypes.func,
    status: PropTypes.string,
    redirectTo: PropTypes.string,
    history: PropTypes.object,
    match: PropTypes.object,
    startSession: PropTypes.func
};

function mapDispatchToProps(dispatch) {
    return {
        getTransferInfo: (nonce) => dispatch(aa.getTransferInfo(nonce)),
        startSession: () => dispatch(startSession())
    };
}

function mapStateToProps(state) {
    return {
        status: state.authentication.status,
        redirectTo: state.authentication.redirectTo
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthContainer));
